// 機關清單的共用元件：導演的調整面板、後台編輯頁「機關」分頁都用這一套外觀
//   GroupTitle = 一組的標題（圖示 + 名字 + 改過的小點）；Tiles = 組內的小方塊編號
import { Anchor, ArrowLeftRight, ArrowUpDown, CheckCheck, RefreshCcw, RotateCw, Spline, type LucideIcon } from 'lucide-react';
import type { MechShape } from '../../lib/adjust/mechGroups';
import Icon from '../Icon';
import './AdjustStage.css';

export const SHAPE_ICON: Record<MechShape, LucideIcon> = {
  spin: RotateCw, flip: RefreshCcw, slide: ArrowLeftRight, lift: ArrowUpDown, arc: Spline, hoist: Anchor,
};

/** 一組的標題：點它全選整組（或選這組吊掛 / 這一個） */
export function GroupTitle({ icon, title, count, changed, on, onClick, hint }: {
  icon: LucideIcon; title: string; count?: number; changed: boolean; on: boolean; onClick: (e: React.MouseEvent) => void; hint: string;
}) {
  return (
    <button type="button" className={'adjust-group__title' + (on ? ' is-on' : '')} onClick={onClick} title={hint}>
      <Icon icon={icon} className="adjust-group__icon" />
      <span className="adjust-group__name">{title}</span>
      {changed && <span className="adjust-dot" aria-label="這個 cue 改過" />}
      {count != null && <Icon icon={CheckCheck} size="xs" className="adjust-group__all" />}
    </button>
  );
}

export function Tiles({ members, isChanged, isOn, onPick, hint = '　Ctrl 加減選、Shift 連選' }: {
  members: { def: { id: string; name: string }; tile: string }[];
  isChanged: (id: string) => boolean;
  isOn: (id: string) => boolean;
  onPick: (e: React.MouseEvent, id: string) => void;
  /** 滑鼠提示接在名字後面 */
  hint?: string;
}) {
  return (
    <div className="adjust-tiles">
      {members.map(({ def: m, tile }) => (
        <button
          key={m.id}
          type="button"
          className={'adjust-tile' + (isChanged(m.id) ? ' is-changed' : '') + (isOn(m.id) ? ' is-on' : '')}
          aria-pressed={isOn(m.id)}
          aria-label={m.name}
          onClick={(e) => onPick(e, m.id)}
          title={(isChanged(m.id) ? `${m.name}（這個 cue 改過）` : m.name) + hint}
        >{tile}</button>
      ))}
    </div>
  );
}
